module.exports = __webpack_public_path__ + "static/img/logo.4475637.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 1